import { formatNumber } from "util/formatNumber";

export const EMANIFEST_OVERRIDE_EXPLANATION =
  "Box 18a override: replaces the e-Manifest amount in reports and generator status.";

/**
 * Plain text for tooltips and copy: the Box 11 amount, plus the Box 18a
 * override when one is set. Null when there is nothing to show.
 */
export function formatEManifestAmountWithOverride(
  eManifestAmount: number | null | undefined,
  eManifestAmountOverride: number | null | undefined
): string | null {
  const box11 = eManifestAmount ? `${formatNumber(eManifestAmount)} lbs` : null;
  if (eManifestAmountOverride == null) return box11;
  const override = `Box 18a override of the e-Manifest amount: ${formatNumber(eManifestAmountOverride)} lbs, used for reporting`;
  return box11 ? `${box11} (Box 11). ${override}` : override;
}

/**
 * Stream-level e-Manifest amount when Box 18a overrides change the total: the
 * Box 11 sum, then the sum with overrides applied. Null when the two agree or
 * either is missing, so callers show only the plain Box 11 amount.
 */
export function formatStreamEManifestAmountWithOverrides(
  eManifestAmount: number | null | undefined,
  eManifestAmountWithOverride: number | null | undefined
): string | null {
  if (eManifestAmount == null || eManifestAmountWithOverride == null) return null;
  if (eManifestAmount === eManifestAmountWithOverride) return null;
  return `${formatNumber(eManifestAmount)} lbs (Box 11) · ${formatNumber(eManifestAmountWithOverride)} lbs with Box 18a overrides`;
}
